<template>
  <v-autocomplete
    :prepend-icon="preIcon"
    :value="country"
    :items="filterCountries"
    :label="myLabel"
    @change="changedTo"
    @click:clear="clear"
    :loading="loading"
    :clearable="clearable"
    :rules="rules"
    :dense="dense"
    :search-input.sync="filter"
    autocomplete="nope"
    :disabled="disabled"
    :no-filter="true"
  >
    <template v-slot:selection="data">
      <div ripple class="height32">
        <v-img
          :src="data.item.flag"
          class="flag-img"
          style="margin:5px 5px 0 0 ;float:left;"
          v-if="hideFlag == null"
        ></v-img>
        <div class="text-title" v-if="isd != null">+{{ data.item.isd }}</div>
        <h5 v-if="hideName == null" class="text-title">{{ data.item.name }}</h5>
      </div>
    </template>
    <template v-slot:item="data">
      <v-list-item ripple>
        <v-list-item-content>
          <v-list-item-title>
            <v-img
              :src="data.item.flag"
              height="20"
              width="24"
              style="float:left; margin-right:10px"
            ></v-img>
            <div style="width:40px;float:left">+{{ data.item.isd }}</div>
            <div>{{ data.item.name }}</div>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
  </v-autocomplete>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import common from "@/store/common/module/common";
import { commonMixin } from "@/mixins/common";

import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "CountrySelect",
  props: {
    value: {
      default: false,
    },
    isd: {
      default: null,
    },
    hideName: {
      default: null,
    },
    hideFlag: {
      default: null,
    },
    label: {
      default: "Country",
    },
    clearable: {
      default: false,
    },
    disabled: {
      default: false,
    },
    dense: {
      default: false,
    },
    rules: {
      default: () => [],
    },
    preIcon: {
      default: "",
    },
    madatoryMark: {
      default: false,
    },
  },
  mixins: [Themeable, commonMixin],
})
export default class CountrySelect extends (Vue, Themeable) {
  country = null;
  countries = [];
  loading = true;
  filter = "";

  get myLabel() {
    return this.label + "" + (this.madatoryMark ? "*" : "");
  }

  get filterCountries() {
    let filterby = this.filter;
    filterby = filterby != null ? filterby.toLowerCase() : "";
    if (filterby == "") return this.countries;
    const fc = this.countries.filter(function (c) {
      return (
        c.isd.toString().indexOf(filterby) >= 0 ||
        c.name.toLowerCase().indexOf(filterby) >= 0
      );
    });
    return fc;
  }

  changedTo(newVal) {
    this.filter = "";
    if (newVal) this.country = newVal;
    if (newVal && newVal.name && this.isd == null) {
      this.$emit("input", newVal.name);
      return;
    }
    if (newVal && newVal.isd && this.isd != null)
      this.$emit("input", newVal.isd);

    if (!newVal) this.$emit("input", null);
  }

  setDefault() {
    if (this.value) {
      for (let i = 0; i < this.countries.length; i++) {
        if (
          this.countries[i].name === this.value ||
          this.countries[i].isd === this.value
        ) {
          this.country = this.countries[i];
          break;
        }
      }
    }
  }

  clear() {
    this.filter = "";
    this.country = null;
    this.$emit("input", null);
  }

  async mounted() {
    await common.populateCountries();
    this.countries = common.countries;
    this.setDefault();
    this.loading = false;
  }

  @Watch("value")
  async onValueChange() {
    if (this.value == "" || this.value == null) {
      this.country = null;
    }
    await common.populateCountries();
    this.countries = common.countries;
    this.setDefault();
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 42px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
.flag-img {
  float: left;
  margin-right: 10px;
  height: 20px;
  width: 24px;
  margin: 5px 10px 2px 0;
}
</style>
